module.exports = __webpack_public_path__ + "core-img/date-input.79399c21cd132ab50777c76f9f45490c.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/gfx/date-input.png
// module id = 79
// module chunks = 0